<app-accordion title="PVDs" (visibleChange)="handleVisible($event)">
  <div class="header-content" header-content>
    @if (daysData) { @if (!daysData.pvds && daysData.pvds !== 0) {
    <p-skeleton width="1.5rem" height="1.5rem" />
    } @else {
    <div class="days pvds">{{ daysData.pvds }}</div>
    } }
  </div>
  @if (visible) {
  <div class="nested-content">
    <div class="bordered-content rounded-sm">
      <div class="row-group">
        <div class="label-value col">
          <div class="multi-value">{{ daysData.pvdTimeline.years }}</div>
          <div>Period</div>
        </div>
        <div class="label-value col">
          <div class="days pvds nested">{{ daysData.pvds }}</div>
          <div>PVDs</div>
        </div>
      </div>
      <div class="width-100">
        @for (month of daysData.pvdTimeline.months; track $index) {
        <div class="row-group">
          <div class="label-value">
            <div class="label">{{ month.month }}</div>
            <div class="multi-value">{{ month.pvds }}</div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }
</app-accordion>
